export function assigneeIdFromStoredValue(stored: unknown): string | undefined {
  if (stored == null) {
    return undefined;
  }
  if (typeof stored !== 'string') {
    return undefined;
  }
  const trimmed: string = stored.trim();
  if (trimmed.length === 0) {
    return undefined;
  }
  if (trimmed === 'undefined') {
    return undefined;
  }
  return trimmed;
}
